import { adminSupportQueryKeys as e } from "../supportQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { supportApi as n } from "@maat/api-main";
//#region src/support/admin/useAdminArticlesQuery.ts
var r = (r = {}) => t({
	queryKey: e.articles(r),
	fetchPage: (e) => n.adminListArticles({
		...r,
		page: e
	}),
	key: "items"
});
//#endregion
export { r as useAdminArticlesQuery };
